import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { FilterValueType } from '../../filtered-search.component';

@Component({
  selector: 'date-filter',
  styleUrl: '../filtered-search-option.component.scss',
  template: `
    <mat-form-field
      class="filter-form"
      appearance="outline"
      (click)="$event.stopPropagation(); $event.preventDefault()"
      (keyup)="$event.stopPropagation(); $event.preventDefault()"
      [attr.data-test]="'filter-date'"
    >
      <mat-label>
        {{ 'Filter.Value' | translate: locale.language }}
      </mat-label>
      <input [attr.data-test]="'filter-date-input'" matInput [formControl]="control" [matDatepicker]="picker" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DateFilterComponent {
  @Input() control: FormControl<FilterValueType>;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
